<div class="d-flex d-md-flex justify-space-between align-items-center m-b-10">
  @if (postType == "channels") {
    <div class="channel-title">
      <fui-heading [text]="betaStringId ? selectedChannel.title : ('com.skills.' + selectedChannel.string_id | translate)" [level]="2" fontSize="f7"></fui-heading>
    </div>
  }
  @if (postType == "topics") {
    <div class="channel-title">
      <fui-heading [text]="selectedTopic.title" [level]="2" fontSize="f7"></fui-heading>
      <span class="t-14">Added on {{ selectedTopic.start_date.toDate() | date }}</span>
      @if (selectedTopic.archived) {
        <span>&nbsp;&nbsp;&bull;&nbsp;&nbsp;</span>
      }
      @if (selectedTopic.archived && selectedTopic.date_archived) {
        <span class="t-14 c-red">Archived on {{ selectedTopic.date_archived.toDate() | date }}</span>
      }
    </div>
  }
</div>
@if (selectedChannel && communityService.channelSplashes[selectedChannel.string_id] && !betaStringId) {
  <div class="channel-slug" [innerHTML]="communityService.channelSplashes[selectedChannel.string_id] | safe: 'html'"></div>
}
@if (selectedTopic && selectedTopic.description) {
  <div class="topic-slug" [innerHTML]="selectedTopic.description | safe: 'html'"></div>
}
<div class="posts p-x-5">
  @if ((!communityService.profile || !communityService.profile.status || communityService.profile.status == "active") && (selectedChannel || (selectedTopic && !selectedTopic.archived))) {
    <myp-create-post-input #createPostInput [selectedChannel]="selectedChannel" [topic]="selectedTopic" [betaStringId]="betaStringId"></myp-create-post-input>
  }
  <div class="m-t-20">
    @if (createPostInput?.queuedPosts?.length > 0) {
      @for (queuedPost of createPostInput.queuedPosts; track queuedPost) {
        <div>
          @if (!queuedPost.scheduled_date) {
            <myp-comment [comment]="queuedPost" [isCommunityPost]="true" [index]="i" [queued]="true" [displayedSection]="postType"></myp-comment>
          }
        </div>
      }
    }
    @if (communityService.pendingPosts) {
      @for (pendingPost of communityService.pendingPosts; track pendingPost) {
        <div>
          @if (!pendingPost.scheduled_date) {
            <myp-comment [comment]="pendingPost" [isCommunityPost]="true" [index]="i" [queued]="true" [displayedSection]="postType"></myp-comment>
          }
        </div>
      }
    }
    @if (betaStringId && (betaCommunityService.showBetaType || betaCommunityService.showBetaStatus || betaCommunityService.showBetaReviewStatus || betaCommunityService.showBetaAuthor)) {
      <div style="max-width: 1000px; margin: 10px auto">
        Filters Applied:
        @if (betaCommunityService.showBetaType) {
          <span class="item-tag t-12 font-weight-bold">Type: {{ betaCommunityService.betaFilterReadableValues[betaCommunityService.showBetaType] || betaCommunityService.showBetaType }}</span>
        }
        @if (betaCommunityService.showBetaStatus) {
          <span class="item-tag t-12 font-weight-bold">Status: {{ betaCommunityService.betaFilterReadableValues[betaCommunityService.showBetaStatus] || betaCommunityService.showBetaStatus }}</span>
        }
        @if (betaCommunityService.showBetaReviewStatus) {
          <span class="item-tag t-12 font-weight-bold">
            Review Status: {{ betaCommunityService.betaFilterReadableValues[betaCommunityService.showBetaReviewStatus] || betaCommunityService.showBetaReviewStatus }}
          </span>
        }
        @if (betaCommunityService.showBetaAuthor && communityService.betaAuthorMap && communityService.betaAuthorMap[betaCommunityService.showBetaAuthor]) {
          <span class="item-tag t-12 font-weight-bold">Author: {{ communityService.betaAuthorMap[betaCommunityService.showBetaAuthor].name }}</span>
        }
        &nbsp;&nbsp;
        <span class="small-btn" (click)="resetFilters.next(true)">Reset Filters</span>
      </div>
    }
    @if (loading) {
      <div class="text-center m-y-30">
        <fa-icon icon="spinner" animation="spin"></fa-icon>
        Loading posts...
      </div>
    }

    @if (!loading) {
      @if (displayType == "detailed" || !betaStringId) {
        <ul class="list-group">
          @for (post of communityService.activeParentPosts; track post; let i = $index) {
            @if ((post.scheduled_date && selectedChannel.id === "my_posts" && post.author.id == user.id) || !post.scheduled_date) {
              <li class="list-group-item border-0 p-0 bg-transparent">
                <myp-comment
                  [betaStringId]="betaStringId"
                  [comment]="post"
                  [isCommunityPost]="true"
                  [replies]="communityService.activeParentThreadMap[post.key]"
                  (replied)="sendReply($event)"
                  (postEdited)="initPosts()"
                  (deleteIndexSet)="postDeleteIndex = $event"
                  [index]="i"
                  (channelSelected)="channelSelected.next($event)"
                  (topicSelected)="topicSelected.next($event)"
                  [displayedSection]="postType"
                  [scheduled]="true"
                ></myp-comment>
              </li>
            }
          }
        </ul>
      }
      @if (displayType == "list" && betaStringId) {
        <div>
          <ul class="list-group">
            @for (post of communityService.activeParentPosts; track post; let i = $index) {
              <li class="list-group-item border-0 p-0 bg-transparent">
                <myp-list-item
                  [photo]="post.author.photo ? post.author.photo : './assets/images/default_avatar.jpg'"
                  [title]="appService.decodeHtmlCharacters(helperService.stripHtml(post.subject, true))"
                  [subData]="[(post.created.toDate() | date: 'MMM Do [at] hh:mm' : true) + ' by ' + post.author.name, getBetaItemStats(post), getChannelString(post.channels)]"
                  [item]="post"
                  [alignTop]="true"
                  (itemClicked)="goToPost(post)"
                >
                  <div class="button-content">
                    <button class="fa-button m-r-20" (click)="copyLink(post, $event)">
                      <fa-icon aria-label="Copy" icon="copy" ngbTooltip="Copy Link"></fa-icon>
                    </button>
                  </div>
                </myp-list-item>
                <hr />
              </li>
            }
          </ul>
        </div>
      }
      @if (!communityService.activePostsLimitReached) {
        <div class="text-center m-y-30">
          @if (user.active_subscription || betaStringId) {
            <button type="button" class="btn btn-transparent small-btn" (click)="showMore()">{{ "com.show_more_posts" | translate }}</button>
          }
          @if (!user.active_subscription && !betaStringId) {
            <button type="button" class="btn btn-transparent small-btn" (click)="upgrade()">{{ "com.upgrade_more_posts" | translate }}</button>
          }
        </div>
      }
      @if (communityService.activeParentPosts && !communityService.activeParentPosts.length) {
        <div class="text-center m-y-20 gothic">
          <span>
            {{
              "com.no_posts_found" | translate: { channel: selectedChannel ? (betaStringId ? selectedChannel.title : ("com.skills." + selectedChannel.string_id | translate)) : selectedTopic.title }
            }}
          </span>
        </div>
      }
    }
  </div>
</div>
